import React from 'react';
import './Error.scss';
import ButtonMUI from '../../../shared/ButtonMUI';
import {Link} from 'react-router-dom';
import {mainPath, rootAuthPath} from '../../../routes/paths';
import ErrorImages from '../../../assets/images/auth/500.jpg';

const ErrorPage = () => {
  return (
    <div className='error-page__wrapper'>
      <div className='error-page__content'>
        <div className='error-page__images'>
          <img src={ErrorImages} alt='images' />
        </div>
        <div className='error-page__title'>Щось пішло не так</div>
        <div className='error-page__descriptions'>
          Вибачте за незручності! Виникла внутрішня помилка сервера, і ми працюємо над її усуненням
        </div>
        <div className='error-page__text'>
          Якщо проблема не зникне, будь ласка, зв'яжіться з нашою техпідтримкою для допомоги.
        </div>

        <ButtonMUI component={Link} to={localStorage.token ? mainPath.home : rootAuthPath}>
          Закрити
        </ButtonMUI>
      </div>

      <div className='error-page__subscribe'>© 2024 ДАР ®. Всі права захищено.</div>
    </div>
  );
};

export default ErrorPage;
